import RatioImage from './RatioImage'

export default RatioImage;